export const COOKIE_POLICY = 'cookie-policy';
